// Shared chart helpers — single source of truth for the candle-fetch boundary.
// Imported by BOTH App.js (More Info chart, dead chartData poll, candle cache)
// and SignalChart.js (dashboard chart), so there is ONE definition of each.

export const granularityMap = {
  "1h": 3600,
  "6h": 21600,
  "1d": 86400,
};

// Source-agnostic candle-order boundary (Build 5).
// Canonical order = NEWEST-FIRST (Coinbase native). Detects the incoming order
// from the first two timestamps and reverses ONLY if the source is oldest-first.
// For Coinbase (already newest-first) this is a no-op by construction.
export const normalizeCandles = (raw) => {
  if (!Array.isArray(raw) || raw.length < 2) return raw;
  const ts = (c) => (Array.isArray(c) ? c[0] : c?.time);
  const t0 = ts(raw[0]);
  const t1 = ts(raw[1]);
  // Oldest-first (ascending time) → flip to canonical newest-first.
  if (typeof t0 === "number" && typeof t1 === "number" && t0 < t1) {
    return raw.slice().reverse();
  }
  // Already newest-first (descending), or indeterminate → return unchanged.
  return raw;
};
